import React from "react";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import loadable from '@loadable/component'


const CustomItemGroupConf = {
  icon: <GroupWorkIcon />,
  list: loadable(() => import("./ItemGroupList")),
  edit: loadable(() => import("./ItemGroupEdit")),
  create: loadable(() => import("./ItemGroupCreate")),
  options: {
    label: "Item Groups",
    items: true,
  },
};

export default CustomItemGroupConf;
